import { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import subscribe from 'subscribe-event';

import { PROGRESS_COMPLETE } from '../../api/constants';
import API from '../../api/index';
import transitionEndEvent from '../../utils/whichTransitionEndEvent';
import Overlay from '../Overlay/index';

import styles from './rprogress-styles.less';

const CYCLE_TYPE = 'cycle';
const CYCLE_PERCENTS = 25;
const TIMEOUT_DELAY_FOR_ANIMATIONS = 500;

const RProgress = ({ className, type, color }) => {
    const [progress, setProgress] = useState(0);
    const [active, setActive] = useState(false);
    const progressRef = useRef();
    const node = useRef();
    useEffect(() => {
        node.current = document.createElement('div');
        document.body.appendChild(node.current);

        return () => {
            document.body.removeChild(node.current);
        };
    }, []);

    useEffect(() => {
        API.subscribe((event) => {
            const { data } = event;
            let unsubscribe;
            let timeout;

            const hideProgress = () => {
                unsubscribe();
                clearTimeout(timeout);

                setProgress(0);
                setActive(false);
            };

            setProgress(data.position);
            setActive(true);

            if (data.type === PROGRESS_COMPLETE) {
                if (progressRef.current && type !== CYCLE_TYPE) {
                    unsubscribe = subscribe(progressRef.current, transitionEndEvent, hideProgress);
                    // Run timeout in case transitionEndEvent failed for some reasons
                    timeout = setTimeout(hideProgress, TIMEOUT_DELAY_FOR_ANIMATIONS);
                } else {
                    setProgress(0);
                    setActive(false);
                }
            }
        });
    }, [type]);

    if (!progress && !node.current) {
        return null;
    }

    let percents = progress;
    let cycleClass;
    if (type === CYCLE_TYPE) {
        percents = CYCLE_PERCENTS;
        cycleClass = 'rprogress_cycle';
    }

    const stylesObj = {
        width: `${percents}%`,
    };
    if (color) {
        stylesObj.backgroundColor = color;
    }
    const classes = `${styles.rprogress || 'rprogress'} ${cycleClass ? styles[cycleClass] || cycleClass : ''} ${
        className || ''
    }`;

    return createPortal(
        <Overlay visible={active}>
            <div className={classes} style={stylesObj} ref={progressRef}>
                {' '}
            </div>
        </Overlay>,
        node.current
    );
};

export default RProgress;
